module.exports = __webpack_public_path__ + "static/img/icon_line@2x.4bf6b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/icon_line@2x.png
// module id = iQHj
// module chunks = 0